import { render, staticRenderFns } from "./VasionBrowseFolders.vue?vue&type=template&id=49cd3276&scoped=true"
import script from "./VasionBrowseFolders.vue?vue&type=script&lang=js"
export * from "./VasionBrowseFolders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cd3276",
  null
  
)

export default component.exports